import React from 'react';

import Wizard from '../../../components/wizard';
import {
  QrCodePreview,
  TrackingSnippetPanel,
  WebEmbedInfoForm,
  WebEmbedTargetingForm
} from './webEmbedStepContent';
import { isValidDestinationUrl } from '../webEmbedUtils';

const createWebEmbedSteps = ({
  webEmbed,
  onChange,
  onActivate,
  attributionWindows,
  campaignOptions,
  campaignTotalSize,
  onLoadCampaigns,
  selectorLoading,
  selectorError,
  activationError,
  onRetrySelectors
}) => [
  {
    title: 'Web Embed details',
    description: 'Set the name and destination URL.',
    required: true,
    validation: () => webEmbed.name.trim().length > 0 && isValidDestinationUrl(webEmbed.destinationUrl),
    content: (
      <WebEmbedInfoForm
        webEmbed={webEmbed}
        onChange={onChange}
        showDestinationUrl
        disabled={!!webEmbed.id}
      />
    )
  },
  {
    title: 'Attribution',
    description: 'Select campaigns and attribution window.',
    required: true,
    validation: () =>
      !selectorLoading &&
      !selectorError &&
      webEmbed.campaigns.length > 0 &&
      !!webEmbed.attributionWindow,
    content: (
      <WebEmbedTargetingForm
        webEmbed={webEmbed}
        onChange={onChange}
        attributionWindows={attributionWindows}
        campaignOptions={campaignOptions}
        campaignTotalSize={campaignTotalSize}
        onLoadCampaigns={onLoadCampaigns}
        isLoading={selectorLoading}
        error={selectorError}
        onRetry={onRetrySelectors}
        disabled={!!webEmbed.id}
      />
    )
  },
  {
    title: 'Activation and QR code',
    description: 'Activate and retrieve the short URL.',
    required: true,
    validation: () => true,
    nextButtonTitle: webEmbed.id ? 'Next' : 'Activate',
    onNext: () => (webEmbed.id ? true : onActivate().then(() => false)),
    content: <QrCodePreview webEmbed={webEmbed} error={activationError} />
  },
  {
    title: 'Tracking code',
    description: 'Install the snippet and verify the connection.',
    required: true,
    validation: () => !!webEmbed.id,
    submitButtonTitle: 'Done',
    content: <TrackingSnippetPanel webEmbed={webEmbed} />
  }
];

const WebEmbedWizard = props => (
  <div id="web-embed-creation">
    <Wizard
      title="Create a new web embed"
      icon="keyword"
      steps={createWebEmbedSteps(props)}
      onSubmit={props.onSubmit}
      onCancel={props.onCancel}
    />
  </div>
);

export default WebEmbedWizard;
